import { sdkChannelInfoSchema } from "@/state/sdk-channel-info-state";
import type { ApiService } from "./api";
import type { Logger } from "@/utils/logger";

export class WebAppService {
  constructor(
    private readonly apiService: ApiService,
    private readonly logger: Logger,
  ) {
    this.apiService = apiService;
    this.logger = logger.extend(this.constructor.name);
  }

  async getWebApp() {
    const response = await this.apiService.GET("/web-apps");

    const parsed = sdkChannelInfoSchema.safeParse(response);
    if (!parsed.success) {
      this.logger.error("Failed to parse web app", {
        error: parsed.error,
      });

      throw new Error(parsed.error.message);
    }

    return parsed.data;
  }
}
